import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import moment from 'moment';
import { Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { ActivityLoggerService } from 'src/app/_shared/service/activity-logger.service';
import constant from 'src/constant.json';
import { LoanComputationService } from '../../service/loan-computation.service';
import { MyHomeState } from '../../state/my-home.state';

@Component({
  selector: 'app-extra-payment',
  templateUrl: './extra-payment.component.html',
  styleUrls: ['./extra-payment.component.scss'],
})
export class ExtraPaymentComponent implements OnInit {
  selectedTabIndex: number;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  constructor(
    private loanComputationService: LoanComputationService,
    private myHomeState: MyHomeState,
    private formBuilder: FormBuilder,
    private activityLoggerService: ActivityLoggerService,

  ) { }

  @Input() mortgageList: any;
  @Input() computedLoan;
  @Input() address;
  private debounceSubject = new Subject<number>();
  private sliderValue = 0;
  mortgage;
  extraPaymentComputedLoan;
  closeByYears = 0;
  closeByMonths = 0;
  saveAmount = 0;
  saveMonth = 0;
  extraPaymentChange = 100;
  newPayoffDate;
  extraPaymentForm = new FormGroup({});
  onDestroyNotifier$ = new Subject();
  activeTabIndex;
  payoffDate;
  remainingTeam;
  totalInterest;
  originalMortgageComputedLoan;
  loggerAddress: any;
  pmxPropertyId;
  extraMoreThenBalanceError;


  ngOnInit() {
    this.selectedTabIndex = 0;
    this.myHomeState.activePropertyDetails$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res && res.basic) {
        this.pmxPropertyId = res.basic.PMXPropertyId;

        this.loggerAddress = {
          city: res.basic.City,
          state: res.basic.StateOrProvince,
          street: res.basic.StreetAddress,
          zip: res.basic.PostalCode,
        };
      }
    });
    this.extraPaymentForm = this.formBuilder.group({
      extraPayment: [100, []],
    });
    this.mortgage = this.mortgageList[0];
    if (this.mortgage?.extraPayment && Number(this.mortgage?.extraPayment)) {
      this.extraPaymentForm.controls.extraPayment.setValue(this.mortgage.extraPayment);
      this.extraPaymentChange = this.mortgage.extraPayment;
    }
    this.calculateLoanComputation();
    this.extraPaymentForm
      .get('extraPayment')
      .valueChanges.pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((value) => {
        if (value > this.computedLoan.principalBalance) {
          this.extraMoreThenBalanceError = 'Input value must not exceed the remaining loan balance';
          return;
        }
        this.extraMoreThenBalanceError = '';
        this.calculateLoan(value);
      });
    this.debounceSubject.pipe(debounceTime(500)).subscribe(() => {
      this.logUserActivity(
        constant.LOGGER.myHome.category,
        constant.LOGGER.myHome.action.payExtra.key,
        this.pmxPropertyId,
        this.loggerAddress
      );
    });

    this.myHomeState.mortgageList$.pipe(
      filter(() => window.location.href.includes('equity-analysis')),
      takeUntil(this.onDestroyNotifier$)
    ).subscribe((data) => {
      if (data) {
        const final = this.setInitialProjection(data)
        const mortgage = final.filter(
          (mortgage, index) => index === this.selectedTabIndex
        );
        this.mortgage = mortgage[0]
        this.calculateLoanComputation();
      }

    });

  }

  onSliderChange(event: any) {
    this.sliderValue = event.value;
    this.debounceSubject.next(this.sliderValue);
  }


  logUserActivity(category, action, pmxPropertyId, address) {
    let loggerParams = {
      category: category,
      action: action,
    };
    let inputData = {
      pmxPropertyId: pmxPropertyId,
      address: address,
    };
    this.activityLoggerService.logActivity(loggerParams, inputData);
  }
  // calculateLoan(event?) {
  //   let principal: number = this.mortgage.principal;
  //   let annualInterestRate: number = this.mortgage.interest;
  //   let loanTermYearsInMonths: number = this.mortgage.term;
  //   let extraPayment = this.extraPaymentForm.controls.extraPayment.value;
  //   const startDate = moment(this.mortgage.startDate);
  //   const monthlyRate = annualInterestRate / 100 / 12;
  //   const totalMonths = loanTermYearsInMonths;
  //   const oldMonthlyPayment = this.pmt(monthlyRate, totalMonths, principal);
  //   let remainingBalance = principal;
  //   let originalTotalInterest = 0;
  //   for (let i = 1; i <= totalMonths; i++) {
  //     const interestPayment = remainingBalance * monthlyRate;
  //     const principalPayment = oldMonthlyPayment - interestPayment;
  //     remainingBalance -= principalPayment;
  //     originalTotalInterest += interestPayment;
  //   }
  //   remainingBalance = principal;
  //   let newTotalInterest = 0;
  //   let monthCounter = 0;

  //   while (remainingBalance > 0) {
  //     monthCounter++;
  //     const interestPayment = remainingBalance * monthlyRate;
  //     const totalPayment = Math.min(remainingBalance + interestPayment, oldMonthlyPayment + extraPayment);
  //     const principalPayment = totalPayment - interestPayment;
  //     remainingBalance -= principalPayment;
  //     newTotalInterest += interestPayment;
  //   }
  //   const oldPayoffDate = startDate.clone().add(totalMonths, 'months');
  //   const newPayoffDate = startDate.clone().add(monthCounter, 'months');
  //   const durationShortenedInMonths = oldPayoffDate.diff(newPayoffDate, 'months'); // Total months shortened
  //   // this.results = {
  //   //   oldMonthlyPayment,
  //   //   newMonthlyPayment: oldMonthlyPayment + extraPayment,
  //   //   oldPayoffDate,
  //   //   newPayoffDate,
  //   //   oldTotalInterest: originalTotalInterest,
  //   //   newTotalInterest,
  //   //   interestSaved: originalTotalInterest - newTotalInterest,
  //   //   shortenLoanBy: durationShortenedInMonths,
  //   // };
  //   this.newPayoffDate = newPayoffDate;
  //   this.saveAmount = originalTotalInterest - newTotalInterest;
  //   this.saveMonth = durationShortenedInMonths;
  // }

  calculateLoan(event?) {

    let principal: number = this.mortgage.principalBalance || this.mortgage.balancePrincipal;
    let annualInterestRate: number = this.mortgage.interest;
    let totalMonths: number = this.mortgage.termBalance;
    let extraPayment = this.extraPaymentForm.controls.extraPayment.value;
    const monthlyRate = annualInterestRate / 100 / 12;
    const oldMonthlyPayment = Math.round(this.pmt(monthlyRate, totalMonths, principal));
    let remainingBalance = principal;
    let originalTotalInterest = 0;

    for (let i = 1; i <= totalMonths; i++) {
      const interestPayment = remainingBalance * monthlyRate;
      const totalPayment = Math.min(remainingBalance + interestPayment, oldMonthlyPayment);
      const principalPayment = totalPayment - interestPayment;

      remainingBalance -= principalPayment;
      originalTotalInterest += interestPayment;
    }

    remainingBalance = principal;
    let newTotalInterest = 0;
    let monthCounter = 0;

    while (remainingBalance > 0) {
      monthCounter++;

      const interestPayment = remainingBalance * monthlyRate;
      const totalPayment = Math.min(
        remainingBalance + interestPayment,
        oldMonthlyPayment + extraPayment
      );
      const principalPayment = totalPayment - interestPayment;

      remainingBalance -= principalPayment;
      newTotalInterest += interestPayment;
    }

    const durationShortenedInMonths = Math.max(0, totalMonths - monthCounter);
    const newPayoffDate = moment(this.payoffDate)
      .subtract(durationShortenedInMonths, 'months');

    this.newPayoffDate = newPayoffDate;
    this.saveAmount = originalTotalInterest - newTotalInterest;
    this.saveMonth = durationShortenedInMonths;

  }

  pmt(rate: number, nper: number, pv: number): number {
    return (rate * pv) / (1 - Math.pow(1 + rate, -nper));
  }

  updateMyHomeValuesInState() {
    let myHomeValues = this.myHomeState.myHomeListValue.filter((myHome) => {
      return myHome.id == this.myHomeState.activeHomeValue.id;
    });
    myHomeValues = myHomeValues[0];
    myHomeValues?.mortgageList.map((mortgage) => {
      if (mortgage.id === this.mortgage.id) {
        this.mortgage.extraPayment = this.extraPaymentForm.controls.extraPayment.value;
      }
    });
    this.myHomeState.homeListUpdateValue = myHomeValues;
  }

  tabChange(event) {
    this.activeTabIndex = event.index;
    this.selectedTabIndex = event.index;
    this.myHomeState.selectedMortgageIndexValue = event.index;
    this.mortgage = this.mortgageList[event.index];
    this.extraPaymentChange = this.mortgage.extraPayment || 100;
    this.calculateLoanComputation();
  }

  setInitialProjection(home) {
    if (home && home.length) {
      const mortgageList = home.map((mortgage) => {
        let loanComputation = this.loanComputationService.computeTotalLoan(
          mortgage.principal,
          mortgage.interest / 100,
          mortgage.term,
          new Date(mortgage.startDate)
        );
        mortgage = { ...mortgage, ...loanComputation };
        mortgage.activeRefinance = this.loanComputationService.computeBalanceLoan(
          loanComputation.principalBalance,
          mortgage.interest / 100,
          15 * 12
        );
        return mortgage;

      });
      return mortgageList;
    }
  }

  calculateLoanComputation() {
    this.originalMortgageComputedLoan = this.loanComputationService.computeTotalLoan(
      this.mortgage.principal,
      this.mortgage.interest / 100,
      this.mortgage.term,
      new Date(this.mortgage.startDate)
    );
    if (this.mortgage.refinance && Number(this.mortgage.refinance.principalBalance)) {
      this.computedLoan = this.loanComputationService.computeTotalLoan(
        this.mortgage.refinance.principalBalance,
        this.mortgage.refinance.interestRate / 100,
        this.mortgage.refinance.termBalance,
        new Date(this.mortgage.startDate)
      );
    } else {
      this.computedLoan = this.originalMortgageComputedLoan;
    }

    const startDate = this.mortgage.startDate;
    const originalDate = moment(startDate);
    this.payoffDate = moment(originalDate)
      .add(this.mortgage.term / 12, 'years')
      .format('YYYY-MM-DDTHH:mm:ss.SSS\\Z');
    const startCurrentDiff = moment().diff(originalDate, 'month');
    const startEndDiff = moment(this.payoffDate).diff(originalDate, 'month');
    let diff = startEndDiff - startCurrentDiff;
    this.remainingTeam = diff;
    this.totalInterest = this.mortgage.interestBalance + this.mortgage.interestPaid;
    this.calculateLoan();
    //this.closeByMonths = this.payoffDate  = New Payoff Date
  }
  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
